import Cookies from "js-cookie";
import { useState } from "react";
import "../../Auth/Auth.css";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import Timer from "../../../components/Timer";
import { useDataContext } from "../../../utils/DataContext";
import { buttonText } from "../../../utils/buttonText";
import { notificationText } from "../../../utils/notificationText";
import { pageText } from "../../../utils/pageText";
function SigninForm(props) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [signinloading, setSigninloading] = useState(false);

  const { updateUserInfo } = useDataContext();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.email) {
      formErrors.email = "Email is required";
    }
    if (!formData.password) {
      formErrors.password = "Password is required";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setSigninloading(true);
      try {
        const uiSettings = localStorage.getItem("daat_ui_settings");
        localStorage.clear();
        if (uiSettings) localStorage.setItem("daat_ui_settings", uiSettings);
        const response = await props.authActions.login(formData);
        if (response) {
          setSigninloading(false);
          // Login successful, save auth.role to LocalStorage
          Cookies.set("user_token", response.data.token);
          // Login successful, navigate to the home page
          navigate("/acquisition");
        } else {
          setSigninloading(false);
          // Login failed, show an error message
          window.alert("Login failed. Please check your credentials.");
        }
      } catch (error) {
        setSigninloading(false);
        const errorMessage = error.message;
        window.alert(errorMessage);
      }
    }
    updateUserInfo();
  };

  return (
    <div className="modern-signin-form">
      <form onSubmit={handleSubmit}>
        <div className="modern-form-title">
          <h2>{pageText("Log in")}</h2>
        </div>
        
        <div className="modern-form-group">
          <label className="modern-label">{pageText("Email Address")}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder=""
            className={classNames("modern-input", {
              "input-error": errors.email,
            })}
          />
          {errors.email && (
            <span className="error-message">{notificationText(errors.email)}</span>
          )}
        </div>
        
        <div className="modern-form-group">
          <label className="modern-label">{pageText("Password")}</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder=""
            className={classNames("modern-input", {
              "input-error": errors.password,
            })}
          />
          {errors.password && (
            <span className="error-message">
              {notificationText(errors.password)}
            </span>
          )}
        </div>

        <div className="modern-form-options">
          <label className="checkbox-label">
            <input type="checkbox" className="modern-checkbox" />
            <span>{pageText("Keep me logged in this browser")}</span>
          </label>
        </div>

        <button
          type="submit"
          className="modern-submit-btn"
          disabled={signinloading}
        >
          {buttonText(signinloading ? (
            <span>
              <Timer loadingStates={[signinloading]} />
            </span>
          ) : (
            "Log in"
          ))}
        </button>
        
        <p className="modern-signup-link">
          {pageText("Don't have an account?")} <a href="/signup">{pageText("Sign up")}</a>
        </p>
      </form>
    </div>
  );
}

export default SigninForm;
